import React from 'react';
export const BolderArrowForthLeft = ({ title, ...rest }) => (
  <svg viewBox="0 0 500 844.3" {...rest}>
    {title && <title>{title}</title>}
    <path d="M444.9 0c14.1 0 28.2 5.4 38.9 16.1 21.5 21.5 21.5 56.4 0 77.9L155.7 422.2l328.2 328.1c21.5 21.5 21.5 56.4 0 77.9s-56.4 21.5-77.9 0L0 422.2l406-406C416.8 5.4 430.9 0 444.9 0z" />
  </svg>
);
